import i18n from 'i18n'
import { memo } from 'react'
import { useAppDispatch } from 'store'
import {
  updateSpotBadgeOrderAction,
  updateSpotBadgeTradeAction,
  updateSpotCurrentOrderTab,
} from 'store/spot/actions'
import { useCurrentSpotOrderTab, useSpotOpenOrders } from 'store/spot/hooks'
import { SpotOrderTabType } from 'store/spot/types'
import { Flex } from 'styles'
import { styled } from '@mui/material'
import useWindow from 'hooks/useWindow'
import { ZKTab, IZKTabRow } from 'components/ZKTab'

const orderTabs = [
  {
    value: SpotOrderTabType.OpenOrder,
    label: i18n.t('user-open-orders'),
  },
  {
    value: SpotOrderTabType.OrderHistory,
    label: i18n.t('user-history-orders'),
  },
  {
    value: SpotOrderTabType.TradeHistory,
    label: i18n.t('user-trade-history'),
  },
]

const StyledWrap = styled(Flex)`
  display: flex;
  ${(props) => props.theme.breakpoints.down('md')} {
    width: 100%;
  }
  margin-bottom: 8px;
`
const Count = styled('span')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 18px;
  font-size: 12px;
  line-height: 18px;
  color: rgba(206, 207, 210, 1);
  margin-left: 4px;
  background-color: rgba(30, 35, 41, 1);
  border-radius: 9px;
`
const TabItem = styled('div')`
  display: flex;
  height: 24px;
  align-items: center;
  padding: 0 8px;
  border-radius: 12px;
  &:hover {
    background-color: rgba(42, 49, 57, 1);
  }
`

export const UserOrdersTabs = memo(() => {
  const dispatch = useAppDispatch()
  const currentOrderTab = useCurrentSpotOrderTab()
  const openOrders = useSpotOpenOrders()
  const { isMobile } = useWindow()

  return (
    <StyledWrap id="zk_order_container">
      <ZKTab
        itemStyle={
          isMobile
            ? { flex: 1, justifyContent: 'center' }
            : { padding: '8px 16px' }
        }
        tabs={orderTabs}
        tabClick={(item: IZKTabRow) => {
          dispatch(updateSpotCurrentOrderTab(item.value))
          if (item.value === SpotOrderTabType.OrderHistory) {
            dispatch(updateSpotBadgeOrderAction(false))
          } else if (item.value === SpotOrderTabType.TradeHistory) {
            dispatch(updateSpotBadgeTradeAction(false))
          }
        }}
        activeValue={currentOrderTab}
        customTabItem={(row: IZKTabRow) => {
          return (
            <TabItem>
              {row.label}
              {row.value === SpotOrderTabType.OpenOrder && (
                <Count>{openOrders?.length}</Count>
              )}
            </TabItem>
          )
        }}
      ></ZKTab>
    </StyledWrap>
  )
})
